// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"388":"595487a1","980":"7cd3fbab"}[chunkId] + ".js";
};